export default __webpack_public_path__ + "static/media/andar_bet.73a11f21.svg";